import React from "react";
import { _Input } from "../../../../../../../_components/Input";
import { CreateNFeContext } from "../../../Context";

import Row from "../../../../../../../_components/Layout/Row";
import Column from "../../../../../../../_components/Layout/Column";

const indPresOptions = [
  {
    label: "0=Não se aplica",
    value: "0",
  },
  {
    label: "1=Operação presencial",
    value: "1",
  },
  {
    label: "2=Operação não presencial, pela Internet",
    value: "2",
  },
  {
    label: "3=Operação não presencial, Teleatendimento",
    value: "3",
  },
  // {
  //   label: "4=Operação com entrega a domicílio",
  //   value: "4"
  // },
  //TODO: Rejeicao: NF-e com indicativo de NFC-e com entrega a domicilio
  {
    label: "5=Operação presencial, fora do estabelecimento",
    value: "5",
  },
  {
    label: "9=Operação não presencial, outros",
    value: "9",
  },
];
const indIntermedOptions = [
  {
    label: "0=Operação sem intermediador (em site ou plataforma própria)",
    value: "0",
  },
  {
    label:
      "1=Operação em site ou plataforma de terceiros (intermediadores/marketplace)",
    value: "1",
  },
];


export default (props) => {
  const context = React.useContext(CreateNFeContext);
  const ref = React.useRef(null);
  function onChangeIndPress(e) {
    const { nfe } = context;
    nfe.identification.ind_pres = e.value
    nfe.identification.allow_intermed_data = e.value !== "0";
    context.handlers.updateNFeData(nfe);
  }
  function onChangeIntermed(e) {
    const { nfe } = context;
    nfe.identification.ind_intermed = e.value;
    context.handlers.updateNFeData(nfe);
  }
  function onChangeCNPJ(e) {
    const { nfe } = context;
    nfe.identification.cnpj_inter = e.value;
    context.handlers.updateNFeData(nfe);
  }
  function onChangeId(e) {
    const { nfe } = context;
    nfe.identification.id_intermed = e.value;
    context.handlers.updateNFeData(nfe);
  }

  function onRender() {
    if (ref.current.classList) {
      const { nfe } = context;
      nfe.identification.ind_pres = "1";
      nfe.identification.id_intermed = "";
      context.handlers.updateNFeData(nfe);
      onChangeIndPress({
        name: undefined,
        value: "0",
      });
    }
  }
  React.useEffect(onRender, [ref.current, context.nfe.identification]);
  return (
    <div className="my-2" ref={ref}>
      <Row>
        <Column xs="12" md="6" lg="6">
          <_Input
            value={context.nfe.identification.ind_pres}
            label="* Indicador de Presença na NF-e"
            type="select"
            onChange={onChangeIndPress}
            options={indPresOptions}
          />
        </Column>
        <Column
          xs="12"
          md="6"
          lg="6"
          hide={!(context.nfe.identification.ind_pres != "0")}
        >
          <_Input
            value={context.nfe.identification.ind_intermed}
            label="* Indicador de Intermediador"
            type="select"
            onChange={onChangeIntermed}
            options={indIntermedOptions}
          />
        </Column>
      </Row>
      <Row hide={!(context.nfe.identification.ind_intermed === "1")}>
        <Column xs="12" md="6" lg="6">
          <_Input
            label="CNPJ do intermediador da transação"
            type="cnpj"
            value={context.nfe.identification.cnpj_inter}
            onChange={onChangeCNPJ}
          />
        </Column>
        <Column xs="12" md="6" lg="6">
          <_Input
            label="Nome de usuário na plataforma"
            placeholder="Ex: joaodasilva"
            onChange={onChangeId}
            value={context.nfe.identification.id_intermed}
          />
        </Column>
      </Row>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/Intermediary/index.jsx